import { render, staticRenderFns } from "./standart-category-tab.vue?vue&type=template&id=0bd88508&"
import script from "./standart-category-tab.vue?vue&type=script&lang=ts&"
export * from "./standart-category-tab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports